import {CoworkBarePanel} from '../admin/CoworkFormPanel';
import {Portal as LumaPortal} from '@headlessui/react';
import React, {useEffect, useId, useRef} from 'react';
import {createPortal} from 'react-dom';
import './CompactListDialog.css';

export default function CompactListDialog({title,onClose,children}:{title:string;onClose:()=>void;children:React.ReactNode}){
  const ref=useRef<HTMLDivElement>(null),id=useId(),close=useRef(onClose);close.current=onClose;
  useEffect(()=>{
    const previous=document.activeElement as HTMLElement|null;
    const keydown=(e:KeyboardEvent)=>{
      if(e.key==='Escape'){e.preventDefault();close.current();}
      if(e.key==='Tab'&&ref.current){
        const controls=Array.from(ref.current.querySelectorAll<HTMLElement>('button:not([disabled]),input:not([disabled]),select:not([disabled]),a[href]'));
        const first=controls[0],last=controls[controls.length-1];
        if(e.shiftKey&&(document.activeElement===first||document.activeElement===ref.current)){e.preventDefault();last?.focus();}
        else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}
      }
    };
    ref.current?.focus();document.addEventListener('keydown',keydown);
    return()=>{document.removeEventListener('keydown',keydown);if(previous?.isConnected)previous.focus({preventScroll:true});};
  },[]);
  return <LumaPortal>{<div className="cw-list-overlay" onMouseDown={e=>{if(e.target===e.currentTarget)onClose();}}><CoworkBarePanel className="cw-list-dialog" ref={ref} role="dialog" aria-modal="true" aria-labelledby={id} tabIndex={-1}><header><h3 id={id}>{title}</h3><button className="rw-button" onClick={onClose} aria-label="Cerrar lista">Cerrar</button></header><div className="cw-list-body">{children}</div></CoworkBarePanel></div>}</LumaPortal>;
}

